import { useState, useEffect } from "react"

/**
 * Hook that returns the current window size and whether it's mobile
 * @param {number} [mobileBreakpoint=768] - The breakpoint for determining mobile vs desktop
 * @returns {Object} { width, height, isMobile } - An object containing the window size and whether it's mobile
 */
export default function useWindowSize(mobileBreakpoint = 768) {
  const isSSR = typeof window === "undefined"

  const [windowSize, setWindowSize] = useState({
    width: isSSR ? null : window.innerWidth,
    height: isSSR ? null : window.innerHeight,
    isMobile: isSSR ? false : window.innerWidth < mobileBreakpoint
  })

  function changeWindowSize() {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
      isMobile: window.innerWidth < mobileBreakpoint
    })
  }

  useEffect(() => {
    window.addEventListener("resize", changeWindowSize)

    return () => {
      window.removeEventListener("resize", changeWindowSize)
    }
  }, [mobileBreakpoint])

  return windowSize
}
